import styled from 'styled-components';

export const LoginContent = styled.div`
  text-align: center;
  color: black;
  height: 100%;

  overflow: auto;
  display: grid;
  grid-template-rows: auto auto;
`;

export const PasswordBox = styled.div`
  margin: auto;
  background: #fff;
  border-radius: 3px;
  width: 250px;
  height: 40px;
  line-height: 40px;

  font-size: 21px;
  letter-spacing: 0.1em;
`;

export const NumpadWrapper = styled.div`
  width: 70%;
  min-width: 250px;
  margin: 0 auto;
`;

export const FunctionsContent = styled.div`
  text-align: center;
  color: black;
  padding: 10px;
`;

export const SubTitle = styled.div`
  font-size: 18px;
  margin-top: 40px;
  margin-bottom: 20px;
`;

export const InfoText = styled.div`
  font-size: 16px;
  letter-spacing: 0.1em;
  font-weight: 300;
`;

export const FullScreenButtonWrapper = styled.div`
  display: inline-block;
  width: 100px;
  margin: 5px;
`;

export const PickList = styled.select`
  width: 300px;
  height: 50px;
  border: none;
  font-size: 16px;
`;

export const PickListOption = styled.option`
  height: 40px;
  font-size: 16px;
`;

export const ComponentWrapper = styled.div`
  width: 300px;
  margin: 30px auto;
`;

export const EmailReceiptWrapper = styled.div`
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 10px;
`;

export const ModeButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 10px;
  margin-bottom: 15px;
`;

export const ModeButtonWrapper = styled.div`
  width: 170px;
  white-space: nowrap;
`;

export const PanelText = styled.div`
  max-width: 320px;
  margin: 0 auto 20px;
  font-size: 15px;
  font-weight: 300;
  line-height: 1.4;
  text-align: center;
`;

export const FullWidth = styled.div`
  grid-column: 1 / -1;
`;

export const LocalPrinterPanel = styled.div`
  width: 320px;
  margin: 20px auto 0;
  text-align: left;
`;

export const PrinterStatus = styled.div<{ connected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-bottom: 10px;

  &::before {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 8px;
    background: ${({ connected }) => (connected ? '#2e9d4f' : '#b0b0b0')};
  }
`;

export const PrinterError = styled.div`
  color: #c0392b;
  font-size: 14px;
  text-align: center;
  margin-bottom: 10px;
`;

export const PrinterButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  margin-bottom: 10px;
`;

export const PanelLabel = styled.div`
  font-size: 15px;
  margin: 20px 0 8px;
  text-align: center;
`;

export const BaudRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
  margin-bottom: 10px;
`;

export const BaudButton = styled.button<{ selected: boolean }>`
  border: 1px solid #333;
  border-radius: 3px;
  padding: 6px 8px;
  font-size: 13px;
  cursor: pointer;
  background: ${({ selected }) => (selected ? '#333' : '#fff')};
  color: ${({ selected }) => (selected ? '#fff' : '#333')};

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const HintText = styled.div`
  font-size: 13px;
  font-weight: 300;
  text-align: center;
  margin: 6px 0;
`;

export const FieldRow = styled.div`
  margin-bottom: 8px;
`;
